import numberStepper from '../components/number-stepper';
import observer from '../libs/observer';

const cartItem = (el) => {
    let instance = {},
        stepperInstance,
        subtotal,
        price,
        settings = {
            numberStepperAttr: 'data-number-stepper',
            subtotalAttr: 'data-subtotal',
            priceAttr: 'data-price',
            cartItemAttr: 'data-cart-item',
            titleAttr: 'data-title',
            descriptionAttr: 'data-description',
            inputAttr: 'data-input'
        },

        getPrice = () => Number(price.getAttribute(settings.priceAttr)),

        setSubtotal = () => {
            subtotal.innerHTML = stepperInstance.getValue() * getPrice();
        },

        toObject = () => {
            let tmp = {};

            tmp[el.getAttribute(settings.cartItemAttr)] = {
                title: el.querySelector(`[${settings.titleAttr}]`).innerHTML,
                description: el.querySelector(`[${settings.descriptionAttr}]`).innerHTML,
                amount: Number(el.querySelector(`[${settings.inputAttr}]`).value),
                price: getPrice(),
                subtotal: Number(subtotal.innerHTML)
            };

            return tmp;
        },

        stepperHandler = () => {

            setSubtotal();

            instance.trigger('subtotalChanged', toObject());
        };

    // Add composites
    Object.assign(instance, observer());

    stepperInstance = numberStepper(el.querySelector(`[${settings.numberStepperAttr}]`), {validationTimeout: 100});
    stepperInstance.on('validated', stepperHandler);
    subtotal = el.querySelector(`[${settings.subtotalAttr}]`);
    price = el.querySelector(`[${settings.priceAttr}]`) || el.closest(`[${settings.priceAttr}]`);

    setSubtotal();

    return instance;
};

export default cartItem;
